import React, {Fragment, useCallback} from 'react';

import {makeGetWhoIndicatesLink} from 'main/factories/usecases/private/remote-home/get-who-indicates';
import whoIndicatesImgLg from 'presentation/assets/images/who-indicates-lg.webp';
import whoIndicatesImgSm from 'presentation/assets/images/who-indicates-sm.webp';
import {AlertModal} from 'presentation/components';
import {useGetEndpointUrl} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {PerksTaggingEnum} from 'main/analytics/gaTagsEnum';
import {PerksCard} from '../PerksCard';

const {whoIndicatesTitle} = translations['pt-br'].privateFlow.perks;
const {recommendation} = translations['pt-br'].privateFlow.services;
const {serverError, unexpectedError, serverErrorTitle, tryAgain, learnMore} =
	translations['pt-br'].commons;

export function Recommendation() {
	const {isError, setIsError, getLink, isLoading} = useGetEndpointUrl(recommendation);

	const {isMobile} = useMediaQueries();

	const indicationImg = isMobile ? whoIndicatesImgSm : whoIndicatesImgLg;

	const handleClick = useCallback(() => {
		getLink(makeGetWhoIndicatesLink);
	}, []);

	return (
		<Fragment>
			<PerksCard
				dataTagId={PerksTaggingEnum.CLICK_QUEM_INDICA_BENEFICIOS}
				cardImage={indicationImg}
				description={whoIndicatesTitle}
				title={recommendation}
				handleAction={handleClick}
				isLoading={isLoading}
				buttonText={learnMore}
				buttonIcon="external-link-default"
			/>
			{isError ? (
				<AlertModal
					open={isError}
					onClose={() => setIsError(false)}
					description={serverError}
					title={serverErrorTitle}
					headerTitle={unexpectedError}
					buttonLabel={tryAgain}
					variant="info"
				/>
			) : null}
		</Fragment>
	);
}
